import React from "react";
import Layout from "src/components/Layout";
import NavBarDoIt from "src/components/LiterasiKeuangan/NavbarDoItCerdas";
import DoITCERDAS from "./DoItCerdas";
import CaraCerdasOverview from "./CaraCerdasOveriew";
import { LiterasiKeuanganMeta } from "src/data/DataMetatags";
import {
  LiterasiKeuanganBreadcrumb,
  defBreadcrumb,
} from "../../data/DataBreadcrumb";
import NextHead from "src/components/Seo/NextHead";
import BreadcrumbComponent from "src/components/UserInterface/BreadcrumbComponent";
import { MonetizationBanner } from "src/components/IndexPage/MonetizationBanner";

const LiterasiKeungan = (props) => {
  const { breadcrumb, LiterasiKeuanganBreadcrumb, title, description, path } =
    props;
  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={LiterasiKeuanganBreadcrumb} />
      <NavBarDoIt></NavBarDoIt>
      <DoITCERDAS></DoITCERDAS>
      <CaraCerdasOverview></CaraCerdasOverview>
      <MonetizationBanner
        containerMargin={["32px 16px 64px", "80px auto 120px"]}
        titleTextAlign="left"
        titleFontSize={["24px", "40px"]}
        bannerRadius={["16px", "16px"]}
        gap={["24px", "40px"]}
        titleMargin={["0", "0 16px"]}
      />
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = LiterasiKeuanganMeta;
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title,
      },
    },
  ];

  return {
    props: {
      breadcrumb,
      LiterasiKeuanganBreadcrumb,
      title,
      description,
      path,
    },
  };
};

export default LiterasiKeungan;
